import gettext from '@/i18n/gettext';
import i18nKeys from '@/helpers/I18nHelper';

const { $gettext } = gettext;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapFinderError(error: any): string {
  const status = error?.response?.status ?? error?.request?.status;

  if (status === 400) {
    return error.response?.data.detail;
  }
  if (status === 422) {
    const code = error.response?.data.detail.statusCode;
    switch (code) {
      case 1:
        return i18nKeys.couldNotDeterminePayload;
      case 2:
        return `${$gettext('Module ID')} '${
          error.response?.data.detail.moduleId
        }' ${$gettext('not found in the database.')}`;
      case 3:
        return i18nKeys.noTestTrajectoryKnownForTheConfiguration;
      case 4:
        return i18nKeys.robotCannotCarryAPayload;
      default:
        return i18nKeys.internalServerError;
    }
  }
  if (status === 501) {
    return i18nKeys.invalidConfiguration;
  }
  return i18nKeys.internalServerError;
}

export default mapFinderError;
